<div class="slide-container">
  <div id="profile-section">
    <img src="assets/icon-new/empty-avatar.svg">
    <div class="profile-name">
      <ng-template [ngIf]="isLogin" [ngIfElse]="not_login_profile_name">
        <p [textContent]="userName"></p>
        <p [textContent]="mobileNo"></p>
      </ng-template>
      <ng-template #not_login_profile_name>
        <p>کاربر میهمان</p>
      </ng-template>
    </div>
  </div>
  <ul id="link-section">
    <ng-template [ngIf]="!device.isIOS()">
      <ng-container [ngSwitch]="subscriptionStatus">
        <ng-container *ngSwitchCase="SubscriptionStatusEnum.NOT_LOGIN">
          <ng-container *ngTemplateOutlet="BTN_BUY_SUB_TEMPLATE"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="SubscriptionStatusEnum.Not_YET_SUBSCRIPTION">
          <ng-container *ngTemplateOutlet="BTN_BUY_SUB_TEMPLATE"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="SubscriptionStatusEnum.SUBSCRIPTION_EXPIRED">
          <ng-container *ngTemplateOutlet="BTN_BUY_SUB_TEMPLATE"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="SubscriptionStatusEnum.OLD_SUBSCRIPTION">
          <ng-container *ngTemplateOutlet="MESSAGE_SUBSCRIPTION; context: { $implicit: true, type: 'old' }">
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="SubscriptionStatusEnum.NEW_SUBSCRIPTION">
          <ng-container *ngTemplateOutlet="MESSAGE_SUBSCRIPTION; context: { $implicit: false, type: 'new' }">
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <ng-container *ngTemplateOutlet="LOADING_SUB"></ng-container>
        </ng-container>
      </ng-container>
    </ng-template>
    <li *ngIf="isLogin" (click)="[clickNavProfile('profile-edit'), logEvent('profile-edit', 'ویرایش اطلاعات کاربری')]">
      <img src="assets/icon-new/icon-edit-profile.svg" *ngIf="showIcon">
      <p>ویرایش اطلاعات کاربری</p>
    </li>
    <li *ngIf="!isLogin" (click)="[device.goTologinPageNative('/profile')]">
      <img src="assets/icon-new/icon-edit-profile.svg" *ngIf="showIcon">
      <p>ورود کاربر</p>
    </li>
    <li *ngIf="parametersService.clientId !== clientType.iGap"
        (click)="[clickNavProfile('credit'), logEvent('credit', 'کیف پول')]">
      <img src="assets/icon-new/icon-wallet.svg" *ngIf="showIcon">
      <p>اعتبار</p>
    </li>
    <li *ngIf="showCreditCode" (click)="[clickNavProfile('redeem'), logEvent('redeem', 'کد تخفیف')]">
      <img src="assets/icon-new/code-gift.svg" *ngIf="showIcon">
      <p>ثبت کد تخفیف</p>
    </li>
    <li *ngIf="(device.getFeaturesetVersion() <= 0) && isLogin"
        (click)="[clickNavProfile('wishlist'), logEvent('wishliast', 'نشان شده‌ها')]">
      <img src="assets/icon-new/icon-wishlist.svg" *ngIf="showIcon">
      <p>نشان شده‌ها</p>
    </li>
    <li [routerLink]="['/archive']" (click)="[indicator.show(), logEvent('archvie', 'بایگانی')]" *ngIf="isLogin">
      <img src="assets/icon-new/archive-new.svg" *ngIf="showIcon">
      <p>بایگانی</p>
    </li>
    <!-- <li
            *ngIf="(device.getFeaturesetVersion() > 0) && isLogin"
            (click)="clickNavProfile('setScore')">
            <img
                src="assets/icon-new/icon-rate-to-navaar.svg"
                *ngIf="showIcon"
            >
            <p>امتیاز به نوار</p>
        </li> -->
    <li (click)="
            [clickNavProfile('feedback'), logEvent('feedback', 'راهنما و پشتیبانی')]">
      <img src="assets/icon-new/icon-feedback.svg" *ngIf="showIcon">
      <p>راهنما و پشتیبانی</p>
      <span style="flex: 1"></span>
      <span #unread_count_message_goftino id="unread_count_message_goftino">0</span>
    </li>
    <!-- <li (click)="[openSettings(), logEvent('setting', 'تنظیمات')]" *ngIf="!device.isIOS()">
      <img src="assets/icon-new/icon-setting.svg" *ngIf="showIcon">
      <p>تنظیمات</p>
    </li> -->
    <li *ngIf="showAboutMenu" (click)="[clickNavProfile('about'), logEvent('about', 'درباره نوار')]">
      <img src="assets/icon-new/icon-about.svg" *ngIf="showIcon">
      <p>درباره نوار</p>
    </li>
    <li (click)="[logEvent('exit', 'خروج'), exit()]" *ngIf="isLogin">
      <img src="assets/icon-new/icon-exit.svg" *ngIf="showIcon">
      <p>خروج</p>
    </li>
    <li>
      <div class="wrapper-version">
        <span class="app-version" [textContent]="appVersion"></span>
      </div>
    </li>
  </ul>

</div>

<ng-template #BTN_BUY_SUB_TEMPLATE>
  <ng-template [ngIf]="(device.getFeaturesetVersion() >= 2)">
    <li id="container-subscription" *ngIf="(device.getFeaturesetVersion() >= 2)">
      <div id="btn-goto-buy-subcription">
        <navaar-button (onClick)="goToSubscription()" [type-button]="'button'" [color-name]="'orange'">
          <div>
            <span class="icon-navaar-style">
              <navaar-logo-simple-icon></navaar-logo-simple-icon>
            </span>
            <p>خرید اشتراک</p>
          </div>
        </navaar-button>
      </div>
    </li>
  </ng-template>
</ng-template>
<ng-template #MESSAGE_SUBSCRIPTION let-show_goto_state let-id="type">
  <li id="subscription-{{id}}-total-days">
    <p>
      <span [textContent]="remainingTimeSubscription"></span> روز از اشتراک شما باقی‌مانده است.
    </p>
    <a *ngIf="show_goto_state" [routerLink]="['../subscription', 'status']">وضعیت اشتراک ></a>
  </li>
</ng-template>
<ng-template #LOADING_SUB>
  <li id="loading-subscription">
    <navaar-indicator [isShowLoading]="true"></navaar-indicator>
  </li>
</ng-template>
